import { type DropDownProps } from "antd";

import {
    CollapsableControlGroup,
    type ICollapsableControl,
} from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { type EditorControlBreakpointNames } from "commonComponents/btWrappers/editor/core/EditorControlBar/EditorControlBar.types";
import blockquoteControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/BlockquoteControl";
import boldControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/BoldControl";
import bulletListControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/BulletListControl";
import italicControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/ItalicControl";
import orderedListControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/OrderedListControl";
import { redoControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/RedoControl";
import strikethroughControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/StrikethroughControl";
import underlineControl from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/UnderlineControl";
import { undoControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/elements/UndoControl";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

interface ICoreControlGroupProps {
    editor: IEditor;
    editorSize: EditorControlBreakpointNames;
    supportedExtensions: Set<ExtensionName>;
    dropdownPlacement?: DropDownProps["placement"];
}

const coreControls: ICollapsableControl[] = [
    boldControl,
    italicControl,
    underlineControl,
    strikethroughControl,
    bulletListControl,
    orderedListControl,
    blockquoteControl,
    undoControl,
    redoControl,
];

export const isCoreControlGroupVisible = (
    supportedExtensions: Set<ExtensionName>,
    editor: IEditor,
) => {
    return coreControls.some((coreControl) =>
        coreControl.isControlSupported(supportedExtensions, editor),
    );
};

export const CoreControlGroup: React.FC<ICoreControlGroupProps> = ({
    editor,
    supportedExtensions,
    editorSize,
    dropdownPlacement,
}) => {
    return (
        <CollapsableControlGroup
            data-testid="coreControlGroup"
            editor={editor}
            editorSize={editorSize}
            supportedExtensions={supportedExtensions}
            controls={coreControls}
            dropdownPlacement={dropdownPlacement}
            gap={0}
            xs={7}
            sm={7}
            md={7}
            lg={7}
            xl={7}
        />
    );
};
